export const en = {
  common_welcome: 'Welcome',
  common_submit: 'Submit',
  common_cancel: 'Cancel',
  common_continue: 'Continue',

  property_info_form_title:
    'Please input the information contained in the unclaimed property letter you received.',
  reference_number_label: 'Reference Number',
  last_name_label: 'Last Name',
  postal_code_label: 'Postal Code',
  reference_number_error: 'Invalid Reference Number',
  last_name_error: 'Last Name is required',
  postal_code_error: 'Postal Code is required',
  property_amount_label: 'Property Amount',
  last_name_info: 'Please use the name on the top left of your letter, this could be your last name or your business name.',
};
